import React from 'react';
import { EmailTemplates } from '../../utils/Helper/enums';

interface IPreviewMessage {
  message: string;
  showPreview: boolean;
  setShowPreview: React.Dispatch<React.SetStateAction<boolean>>;
  className: string;
}

const PreviewMessage: React.FC<IPreviewMessage> = ({
  message,
  showPreview,
  setShowPreview,
  className
}) => {
  const formattedHTML = EmailTemplates.BROADCAST_HTML.replace(
    '{{MESSAGE}}',
    message || '<em>No message provided</em>'
  );
  return (
    <div className="relative inline-block group">
      <div
        className={className}
        onMouseEnter={() => setShowPreview(true)}
        onMouseLeave={() => setShowPreview(false)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path
            d="M10 3C5 3 1.73 7.11 1 10c.73 2.89 4 7 9 7s8.27-4.11 9-7c-.73-2.89-4-7-9-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5
           5 2.24 5 5-2.24 5-5 5zm0-8a3 3 0 100 6 3 3 0 000-6z"
          />
        </svg>
      </div>
      <div
        className={`absolute z-50 bg-white border border-gray-300 shadow-lg rounded-md p-4 text-sm
          bottom-full left-0 mb-2
          max-w-96 w-96 max-h-[300px]
          overflow-hidden
          break-words text-gray-800
          transition-opacity duration-200 ease-in-out
          ${showPreview ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onMouseEnter={() => setShowPreview(true)}
        onMouseLeave={() => setShowPreview(false)}>
        <div dangerouslySetInnerHTML={{ __html: formattedHTML }} />
      </div>
    </div>
  );
};

export default PreviewMessage;
